import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getVariantDetailsErrorState } from '../../../store/selectors/variantDetailsSelectors';
import ThemedErrorMessage from '../../../../common/components/presentation/error/ThemedErrorMessage';

const CustomiseErrorBoundary: FC<any> = ({ children }) => {
  const criticalError = useSelector(getVariantDetailsErrorState);

  if (criticalError) {
    return <ThemedErrorMessage fullPage={true} message={'spc.customise.error.carConfig'} error={criticalError} />;
  }

  return children;
};

export default CustomiseErrorBoundary;
